<template>
  <div :class="['single-select', select && 'select']" @click.stop="change">
    <div class="label">{{label || value}}</div>
    <i class="crm-Icon_selected"></i>
  </div>
</template>

<script>
export default {
  data () {
    return { select: false }
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {},
    checked: {},
    close: {}
  },
  created () {
    this.select = this.value === this.checked
  },
  watch: {
    checked (newValue) {
      this.select = this.value === newValue
    }
  },
  methods: {
    change () {
      if (this.select) {
        if (this.checked !== this.value) { this.select = false }
      } else {
        this.select = true
      }
      this.close && this.close()
      this.$emit('change', this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.single-select {
  position: relative;
  height: 112px;
  display: flex;
  align-items: center;
  color: #595C66;
  box-shadow: 0 1px 0 0 #E9EAEE;
  box-sizing: border-box;
  margin-bottom: 1px;

  &.select {
    color: #F76A31;

    i {
      display: block;
    }
  }

  .label {
    flex: 1;
    font-family: DiDiSans-Pro-Regular;
    font-size: 32px;
    letter-spacing: 0;
    line-height: 40px;
    font-weight: 400;
  }

  i {
    font-weight: 700;
    display: none;
  }
}
</style>
